<template>
    <li class="navbar--list-item" v-on:mouseover="hover = true" v-on:mouseleave="hover = false">
        <a class="navbar--list-item--link" v-bind:class="active ? 'active' : ''" :href="href">
            <div class="navbar--list-item--icon">
                <svg-image
                    :src="icon_src"
                    :active="active || hover"
                    color="nav-icon-color"
                    heightlight="nav-icon-active-color"
                    height="20px"
                    width="20px"
                ></svg-image>
            </div>
            <span class="navbar--list-item--title">{{label}}</span>
        </a>
    </li>
</template>

<script>
    export default {
        name: "NavbarItem",
        props: {
            label: {
                type: String
            },
            href: {
                type: String,
                default: 'javascript:void(0)'
            },
            icon_src: {
                type: String
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                hover: false
            }
        }
    }
</script>
